var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 47.5,
    fill: "white",
    stroke: "#ffffff",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 25C39.5935 25 31.1272 33.4663 31.1272 43.8727C31.1272 48.1744 34.1524 54.5485 40.1189 62.8175C44.4746 68.8541 48.8935 73.7719 48.9376 73.821L49.9999 75L51.0622 73.821C51.1064 73.7721 55.5253 68.8542 59.8809 62.8175C65.8474 54.5484 68.8726 48.1744 68.8726 43.8727C68.8728 33.4663 60.4064 25 50 25ZM49.9999 70.7038C44.7008 64.599 33.9873 50.8206 33.9873 43.8727C33.9871 35.0433 41.1705 27.8599 50 27.8599C58.8296 27.8599 66.0129 35.0433 66.0129 43.8727C66.0129 50.8164 55.2991 64.5976 49.9999 70.7038Z",
    fill: "rgb(54, 63, 73)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 50.9791C53.9247 50.9791 57.1063 47.7975 57.1063 43.8728C57.1063 39.9481 53.9247 36.7665 50 36.7665C46.0753 36.7665 42.8937 39.9481 42.8937 43.8728C42.8937 47.7975 46.0753 50.9791 50 50.9791Z",
    fill: "#ffffff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoLocation);
export default __webpack_public_path__ + "static/media/info_location.2ea08408ebd5b4dd1b4f8cd95652f93d.svg";
export { ForwardRef as ReactComponent };